/**
 * Used to convert address fields into a single string.
 * If full address is used, then you can use it directly, otherwise, you can provide data using separate fields.
 * If full address and fields are not provided, then map will use coordinates.
 * If no address fields are provided, coordinates will be used if available.
 *
 * @param {Address} address - The address object containing fields such as `fullAddress`, `placeName`, `streetName`, `city`, `state`, `county`, `postalCode`, or `location`.
 * @returns {string | undefined} A human-readable address string, or `undefined` if no relevant data is provided.
 */
export function getAddressString(address) {
    const addressValues = [];
    if (address === null || address === void 0 ? void 0 : address.fullAddress) {
        return address.fullAddress;
    }
    if (address === null || address === void 0 ? void 0 : address.placeName) {
        addressValues.push(address.placeName);
    }
    if (address === null || address === void 0 ? void 0 : address.streetName) {
        addressValues.push(address.streetName);
    }
    if (address === null || address === void 0 ? void 0 : address.city) {
        addressValues.push(address.city);
    }
    if (address === null || address === void 0 ? void 0 : address.state) {
        addressValues.push(address.state);
    }
    if (address === null || address === void 0 ? void 0 : address.county) {
        addressValues.push(address.county);
    }
    if (address === null || address === void 0 ? void 0 : address.postalCode) {
        addressValues.push(address.postalCode);
    }
    if (addressValues.length === 0) {
        if (address === null || address === void 0 ? void 0 : address.location) {
            return `${address.location.latitude}, ${address.location.longitude}`;
        }
        return undefined;
    }
    return addressValues.join(', ');
}
